// @core/api/endpoints/platform/create_federation_peer.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateFederationPeerRequest,
  FederationPeerResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Create federation peer
 * Initiates a federation peering request with another platform. The remote platform must accept the request before the connection becomes active.
 */
export async function CreateFederationPeer(
  platform_id: string,
  data: CreateFederationPeerRequest,
  options?: RequestOptions
): Promise<FederationPeerResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/federation/peers`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.post<FederationPeerResponse>(requestPath, data, requestOptions);
}
